import type { Role } from '../types';

type Props = {
  onSelectRole: (role: Role) => void;
};

export function HomeScreen({ onSelectRole }: Props) {
  return (
    <main className="home">
      <a className="home-brand brand-lockup" href="/" aria-label="Peshechka Online — главная">
        <span className="brand-glyph" aria-hidden="true">♟</span>
        <span className="topbar-title">
          <span className="eyebrow">Peshechka Online</span>
        </span>
      </a>
      <div className="home-actions">
        <button className="primary" onClick={() => onSelectRole('trainer')}>Я тренер</button>
        <button className="secondary" onClick={() => onSelectRole('student')}>Я ученик</button>
      </div>
    </main>
  );
}